<script setup lang="ts">
import { tw } from "../../../utils/tailwind";
import type { WithClassAsProps } from "./interface";
import { useCarousel } from "./useCarousel";

defineOptions({
    inheritAttrs: false,
});

const props = defineProps<WithClassAsProps>();

const { carouselRef, orientation } = useCarousel();
</script>

<template>
  <div ref="carouselRef" class="overflow-hidden embla_viewport">
    <div
      :class="
        tw(
          'flex embla_container',
          orientation === 'horizontal' ? '' : '-mt-4 flex-col',
          props.class,
        )"
      v-bind="$attrs"
    >
      <slot />
    </div>
  </div>
</template>
